import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ComboBoxOption } from "@typings/components/comboBox";
import type { Visit } from "@typings/entities/visit";
import type { GetVisitsResponse } from "../list/type";
import { formatDate } from "@utils/formatters";

const LIMIT_VISITS = 30;

export async function searchVisit(
  query?: string,
): Promise<ComboBoxOption<Visit>[]> {
  const params = new URLSearchParams();

  const trimmedQuery = query?.trim();

  if (trimmedQuery) {
    params.append("search", trimmedQuery);
  }

  params.append("limit", LIMIT_VISITS.toString());

  const url = params.toString()
    ? `${apiPaths.visits.list}?${params.toString()}`
    : apiPaths.visits.list;

  const response = await apiClient.get<GetVisitsResponse>(url);

  return response.data.items.map((item) => ({
    label: `${item.location.address} | ${formatDate(item.date)}`,
    value: item.id,
  }));
}
